import { render, staticRenderFns } from "./QProductDataTable.vue?vue&type=template&id=410cdaf0&scoped=true&"
import script from "./QProductDataTable.vue?vue&type=script&lang=js&"
export * from "./QProductDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QProductDataTable.vue?vue&type=style&index=0&id=410cdaf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cdaf0",
  null
  
)

export default component.exports